import {createContext, useContext, useState, useEffect, useCallback} from 'react';
import {fetchDepartments} from "../Api/ViewDepartment";
import {fetchMerchants} from "../Api/ViewMerchantMaster";
import {fetchAllResources} from '../Api/ResourceMaster';
import {fetchItems} from "../Api/ViewItems";
import {fetchRoles} from '../Api/RoleMaster'
import {fetchHSNCodes, fetchTaxCodes} from '../Api/IncomingPo';
import {fetchNodes} from '../Api/NodesApi'

const MasterDataContext = createContext();

export const MasterDataProvider = ({children}) => {
    const [departmentsData,
        setDepartmentsData] = useState([]);
    const [merchantsData,
        setMerchantsData] = useState([]);
    const [resourceData,
        setResourceData] = useState([]);
    const [itemData,
        setItemData] = useState([]);
    const [sideBarData,
        setSideBarData] = useState([]);
    const [roleData,
        setRoleData] = useState([]);
    const [hsnCodes,
        setHsnCodes] = useState([]);
    const [taxCodes,
        setTaxCodes] = useState([]);

    const loadDepartments = async() => {
        try {
            const data = await fetchDepartments();
            // console.log(data, 'data of body types')
            setDepartmentsData(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadMerchants = async() => {
        try {
            const data = await fetchMerchants();
            // console.log(data, 'data of body types')
            setMerchantsData(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadResources = async() => {
        try {
            const data = await fetchAllResources();
            // console.log(data, 'data of body types')
            setResourceData(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadItems = async() => {
        try {
            const data = await fetchItems();
            // console.log(data, 'data of body types')
            setItemData(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    // const loadSideBars = async () => {     try {         const data = await
    // fetchNodes();         // console.log(data, 'data of body types')
    // setSideBarData(data);     } catch (error) {         console.error('Failed to
    // fetch categories:', error);     } };

    const loadSideBars = useCallback(async() => {
        try {
            const data = await fetchNodes();
            setSideBarData(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    }, []);

    const loadRoleMaster = async() => {
        try {
            const data = await fetchRoles();
            console.log(data, 'data of role types')

            const newroleData = data
                ?.map((element) => {
                    console.log(element
                        ?.description, 'element?.description');
                    return {
                        label: element
                            ?.description,
                        value: element
                            ?.code
                    };
                });

            // setRoleData();

            console.log(newroleData, 'roleData')
            setRoleData(newroleData);

        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadHSNCodes = async() => {
        try {
            const data = await fetchHSNCodes();
            // console.log(data, 'data of body types')
            setHsnCodes(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadTaxCodes = async() => {
        try {
            const data = await fetchTaxCodes();
            // console.log(data, 'data of body types')
            setTaxCodes(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    // Fetch subcategories when category changes

    return (
        <MasterDataContext.Provider
            value={{
            departmentsData,
            loadDepartments,
            merchantsData,
            loadMerchants,
            resourceData,
            loadResources,
            itemData,
            loadItems,
            sideBarData,
            loadSideBars,
            roleData,
            loadRoleMaster,
            hsnCodes,
            loadHSNCodes,
            taxCodes,
            loadTaxCodes
        }}>
            {children}
        </MasterDataContext.Provider>
    );
};

export const useMasterDataContext = () => useContext(MasterDataContext);
